import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import GpsCapturePage from './pages/GpsCapturePage';
import axiosInstance from './api/axiosConfig';
import './App.css';

const ALLOWED_ROLES = ['road to market', 'administrateur'];

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('userRole');
    setIsAuthenticated(!!token);
    setUserRole(role);
  }, []);

  const handleLoginSuccess = async (loginData) => {
    const role = loginData.user_role?.toLowerCase();

    // Rôles autorisés directement
    if (ALLOWED_ROLES.includes(role)) {
      localStorage.setItem('authToken', loginData.access_token);
      localStorage.setItem('userRole', loginData.user_role);
      setIsAuthenticated(true);
      setUserRole(loginData.user_role);
      return;
    }

    // Pour les merchandisers : vérifier le flag est_road_to_market
    if (role === 'merchandiser') {
      try {
        // Stocker le token temporairement pour appeler /users/me/
        localStorage.setItem('authToken', loginData.access_token);
        const meRes = await axiosInstance.get('/users/me/');
        const profile = meRes.data?.merchandiser_profile;
        if (profile?.est_road_to_market) {
          localStorage.setItem('userRole', 'road to market');
          setIsAuthenticated(true);
          setUserRole('road to market');
          return;
        }
      } catch (e) {
        console.error('Erreur vérification profil:', e);
      }
      // Accès refusé : nettoyer le token temporaire
      localStorage.removeItem('authToken');
    }

    alert(`Accès refusé. Cette application est réservée aux utilisateurs Road to Market.`);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    setIsAuthenticated(false);
    setUserRole(null);
  };

  // Vérifier si l'utilisateur a le rôle autorisé
  const isRoleAllowed = userRole && ALLOWED_ROLES.includes(userRole.toLowerCase());

  return (
    <div className="App">
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated && isRoleAllowed ? (
              <Navigate to="/" />
            ) : (
              <LoginPage onLoginSuccess={handleLoginSuccess} />
            )
          }
        />
        <Route
          path="/"
          element={
            isAuthenticated && isRoleAllowed ? (
              <GpsCapturePage onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </div>
  );
}

export default App;
